import styled from "styled-components";

const Submit = styled.button`
    display: flex;
    justify-content: center;
    align-items: center;

    background: #FC531B;
    border-radius: 4px;
    padding: 15px;
    margin-top: 12px;
    font-weight: bold;
    font-size: 18px;
    line-height: 18px;
    color: #FFFFFF;

    border: 0;
    outline: 0;

    cursor: pointer;
    text-decoration: none;
    transition: background .3s;

    height: 52px;
    z-index: 1;

    &:hover {
        background: #E64814;
    }

    @media (min-width: 641px) {
        margin-top: 0;
    }

    @media (min-width: 960px) {
        font-size: 16px;
    }
`

export default Submit